import { InputField } from './InputField';
import { useSignInForm } from './hooks';

/** ログイン画面のフォームのコンポーネント。 */
export const SignInForm = () => {
  const {
    username,
    password,
    errorMessage,
    handleChangeUsername,
    handleChangePassword,
    handleClickSignInButton,
  } = useSignInForm();

  return (
    <div className="w-[280px] flex flex-col gap-[48px]">
      <h1 className="text-[40px] text-primary inter-bold">NSER mobile</h1>
      <div className="flex flex-col gap-[32px]">
        <InputField
          labelName="ユーザー名"
          placeholder="ユーザー名を入力"
          inputId="username"
          value={username}
          onChange={handleChangeUsername}
        />
        <InputField
          labelName="パスワード"
          placeholder="パスワードを入力"
          inputId="password"
          type="password"
          value={password}
          onChange={handleChangePassword}
        />
        <button
          className="w-[104px] text-[14px] noto-sans-jp-medium bg-primary text-surface hover:bg-primary/90 px-[20px] py-[10px] rounded-full"
          onClick={handleClickSignInButton}
        >
          ログイン
        </button>
        {errorMessage && <p className="text-red-500">{errorMessage}</p>}
      </div>
    </div>
  );
};
